var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trafficking-screening" },
    [
      _c(
        "div",
        { staticClass: "print-button-container" },
        [
          _c(
            "b-button",
            {
              attrs: { type: "button", variant: "outline-primary", size: "md" },
              on: { click: _vm.printForm }
            },
            [
              _c("span", { staticClass: "button-text" }, [
                _vm._v("\n            Print Form\n        ")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n       Louisiana Child and Youth Sex Trafficking Identification Tool\n    "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm._l(_vm.detailFields, function(item, id) {
        return _c(
          "p",
          { key: id, staticClass: "trafficking-screening__description" },
          [
            _c(
              "span",
              {
                staticClass:
                  "trafficking-screening__description trafficking-screening__description--bold"
              },
              [_vm._v("\n            " + _vm._s(item.title) + ":\n        ")]
            ),
            _vm._v("\n        " + _vm._s(item.value) + "\n    ")
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trafficking-screening__table" },
        [
          _c(
            "b-row",
            { staticClass: "trafficking-screening__row" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("p", { staticClass: "trafficking-screening__header" }, [
                  _c("b", [_vm._v("Section 1: Commercial Sexual Activity")])
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trafficking-screening__header trafficking-screening__description--bold trafficking-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "\n                    Has the child/youth ever engaged in sex or sex acts for anything of value?\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trafficking-screening__header trafficking-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "Items of value may include money, food, a place to stay, drugs, gifts, transportation, or something else. Select all that apply."
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "trafficking-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Exploitation Indicators\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("The child/youth has:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trafficking-screening__checkbox-group" },
                      _vm._l(
                        Object.entries(_vm.section1Fields["Exploitation"]),
                        function(ref) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c(
                            "b-form-checkbox",
                            {
                              key: key,
                              class: {
                                "trafficking-screening__checkbox": true,
                                "font-weight-bold": value.boldDesc
                              },
                              model: {
                                value: _vm.traffickingScreening[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.traffickingScreening, key, $$v)
                                },
                                expression: "traffickingScreening[key]"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(value.desc) +
                                  "\n                        "
                              )
                            ]
                          )
                        }
                      ),
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "trafficking-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                       Vulnerability Indicators\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("The child/youth has:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trafficking-screening__checkbox-group" },
                      _vm._l(
                        Object.entries(
                          _vm.section1Fields["Vulnerability"]["0"]
                        ),
                        function(ref) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c(
                            "b-form-checkbox",
                            {
                              key: key,
                              class: {
                                "trafficking-screening__checkbox": true,
                                "font-weight-bold": value.boldDesc
                              },
                              model: {
                                value: _vm.traffickingScreening[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.traffickingScreening, key, $$v)
                                },
                                expression: "traffickingScreening[key]"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(value.desc) +
                                  "\n                        "
                              )
                            ]
                          )
                        }
                      ),
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("p", [_vm._v("The child/youth is:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trafficking-screening__checkbox-group" },
                      _vm._l(
                        Object.entries(
                          _vm.section1Fields["Vulnerability"]["1"]
                        ),
                        function(ref) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c("div", { key: key }, [
                            !value.type
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        key: key,
                                        class: {
                                          "trafficking-screening__checkbox": true,
                                          "font-weight-bold": value.boldDesc
                                        },
                                        model: {
                                          value: _vm.traffickingScreening[key],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.traffickingScreening,
                                              key,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "traffickingScreening[key]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(value.desc) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            value.type === "other"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass:
                                          "trafficking-screening__checkbox",
                                        model: {
                                          value: _vm.traffickingScreening[key],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.traffickingScreening,
                                              key,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "traffickingScreening[key]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(value.desc) +
                                            "\n                                    "
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "trafficking-screening__otherTextArea"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.traffickingScreening[
                                                  value.textVar
                                                ]
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        }
                      ),
                      0
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("p", { staticClass: "trafficking-screening__header" }, [
                  _c("b", [_vm._v("Section 2: Perpetrator Actions")])
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trafficking-screening__header trafficking-screening__description--bold trafficking-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "\n                    Has someone facilitated, enticed, or benefitted from the sexual activity of the child/youth?\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trafficking-screening__header trafficking-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "This may be a parent, family member, friend, employer, or romantic partner. Select all that apply."
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "span",
                      {
                        staticClass: "trafficking-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Exploitation Indicators\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("Someone has:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trafficking-screening__checkbox-group" },
                      _vm._l(
                        Object.entries(_vm.section2Fields["Exploitation"]),
                        function(ref) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c(
                            "b-form-checkbox",
                            {
                              key: key,
                              class: {
                                "trafficking-screening__checkbox": true,
                                "font-weight-bold": value.boldDesc
                              },
                              model: {
                                value: _vm.traffickingScreening[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.traffickingScreening, key, $$v)
                                },
                                expression: "traffickingScreening[key]"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(value.desc) +
                                  "\n                        "
                              )
                            ]
                          )
                        }
                      ),
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "trafficking-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Vulnerability Indicators\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("Someone is:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trafficking-screening__checkbox-group" },
                      _vm._l(
                        Object.entries(_vm.section2Fields["Vulnerability"]),
                        function(ref) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c("div", { key: key }, [
                            !value.type
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        key: key,
                                        class: {
                                          "trafficking-screening__checkbox": true,
                                          "font-weight-bold": value.boldDesc
                                        },
                                        model: {
                                          value: _vm.traffickingScreening[key],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.traffickingScreening,
                                              key,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "traffickingScreening[key]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(value.desc) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            value.type === "other"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass:
                                          "trafficking-screening__checkbox",
                                        model: {
                                          value: _vm.traffickingScreening[key],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.traffickingScreening,
                                              key,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "traffickingScreening[key]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(value.desc) +
                                            "\n                                    "
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "trafficking-screening__otherTextArea"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.traffickingScreening[
                                                  value.textVar
                                                ]
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        }
                      ),
                      0
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("p", { staticClass: "trafficking-screening__header" }, [
                  _c("b", [_vm._v("Section 3: Current Abuse")])
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trafficking-screening__header trafficking-screening__description--bold trafficking-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "\n                    Is the child/youth currently experiencing abuse, neglect, or other forms of harm?\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "trafficking-screening__header trafficking-screening__description--italic"
                  },
                  [
                    _vm._v(
                      "Please select which types of abuse, neglect, or other forms of harm (from the last 90 days) you have knowledge of or concerns about for this child/youth. Select all that apply"
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-form-group", { attrs: { disabled: "" } }, [
                    _c(
                      "p",
                      {
                        staticClass: "trafficking-screening__description--bold"
                      },
                      [
                        _vm._v(
                          "\n                        Vulnerability Indicators\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "trafficking-screening__checkbox-group" },
                      _vm._l(Object.entries(_vm.section3Fields), function(ref) {
                        var key = ref[0]
                        var value = ref[1]
                        return _c("div", { key: key }, [
                          !value.type
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      key: key,
                                      class: {
                                        "trafficking-screening__checkbox": true,
                                        "font-weight-bold": value.boldDesc
                                      },
                                      model: {
                                        value: _vm.traffickingScreening[key],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.traffickingScreening,
                                            key,
                                            $$v
                                          )
                                        },
                                        expression: "traffickingScreening[key]"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(value.desc) +
                                          "\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          value.type === "other"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass:
                                        "trafficking-screening__checkbox",
                                      model: {
                                        value: _vm.traffickingScreening[key],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.traffickingScreening,
                                            key,
                                            $$v
                                          )
                                        },
                                        expression: "traffickingScreening[key]"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(value.desc) +
                                          "\n                                     "
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "trafficking-screening__otherTextArea"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.traffickingScreening[
                                                value.textVar
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "trafficking-screening__container" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.traffickingScreening.conclusion ===
        _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.NOT_ENOUGH_INFO
          ? _c("div", { staticClass: "mb-0" }, [
              _c("p", { class: _vm.tsConclusionClasses }, [
                _vm._v(
                  _vm._s(
                    _vm.TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                      this.traffickingScreening.conclusion
                    ]
                  ) + " [Monitor]"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(1)
            ])
          : _vm.traffickingScreening.conclusion ===
            _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1
          ? _c("div", { staticClass: "mb-0" }, [
              _c("p", { class: _vm.tsConclusionClasses }, [
                _vm._v(
                  _vm._s(
                    _vm.TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                      this.traffickingScreening.conclusion
                    ]
                  ) + " [Re-Screen]"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(2)
            ])
          : _vm.traffickingScreening.conclusion ===
            _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2
          ? _c("div", { staticClass: "mb-0" }, [
              _c("p", { class: _vm.tsConclusionClasses }, [
                _vm._v(
                  _vm._s(
                    _vm.TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP[
                      this.traffickingScreening.conclusion
                    ]
                  ) + " [Report]"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(3)
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "trafficking-screening__header" }, [
      _c("b", [_vm._v("Final Screening Results and Actions:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "There is not enough information to determine whether the child/youth is experiencing sex trafficking. "
      ),
      _c("b", [_vm._v("Continue to monitor the child/youth")]),
      _vm._v("; upon learning more information, re-screen the child/youth.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "There is concern for possible sex trafficking. If you are a mandatory reporter and have suspicion or knowledge of child abuse (ex: physical or sexual abuse) or neglect (ex: malnourishment), you are required by law to make a mandatory report to DCFS or law enforcement. "
      ),
      _c("b", [
        _vm._v("Screen again in 90 days or upon learning new information")
      ]),
      _vm._v(
        ". Consider referring the child/youth to additional services as needed and appropriate. Consider utilizing the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "The child/youth is considered “indicated” for sex trafficking. As a result, this case warrants review by a Louisiana Human Trafficking Regional Care Coordination Team. "
      ),
      _c("b", [
        _vm._v(
          "Immediately call the DCFS Child Abuse/Neglect Hotline at 855-452-5437 (option 4) to report human trafficking involving a child under the age of 18 years old"
        )
      ]),
      _vm._v(
        ". If the youth is aged 18 years or older, provide them with the National Human Trafficking Hotline at 888-373-7888 and offer to make a referral to a local service provider with expertise in human trafficking. If the suspected victim is an adult with a disability, report also to Adult Protective Services at 800-898-4910. "
      ),
      _c("b", [
        _vm._v(
          "Utilize the group sharing feature on the top right hand corner of this page to share this record with your region's care coordination team"
        )
      ]),
      _vm._v(".")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-380273d7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380273d7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/PrintTraffickingScreening.vue
// module id = 1778
// module chunks = 0